import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Country} from "../../store/state/order.state";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";

@Injectable()
export class CountriesResolver implements Resolve<Observable<Country[]>> {

	constructor(private endpoints: EndpointsProvider) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Country[]> {
		return this.endpoints.common.getAllCountries();
	}

}
